import {
  Box,
  Container,
  CssBaseline,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import { routeModules } from "../../config/routeconfig";
import Loading from "../../common/Laoding";
import { useNavigate } from "react-router-dom";
import Peakseasondashboard from "./Peakseasondashboard";
import Updatepeakseasons from "./Updatepeakseasons";
import Bookingconfigs from "./Bookingconfigs";
import Coupons from "./Coupons";
import Cancellationpolicies from "./Cancellationpolicies";

const Peakseasonmodule = () => {
  const navigate = useNavigate();
  const navItems = routeModules?.peakseason?.sidebar || [];
  const [activeItem, setActiveItem] = useState("");
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!activeItem && navItems.length > 0) {
      setActiveItem(navItems[0].label);
    }
  }, [navItems, activeItem]);

  const renderContent = () => {
    switch (activeItem) {
      case "View Peak Season":
        return <Peakseasondashboard />;
      case "Update Peak Season":
        return <Updatepeakseasons setActiveItem={setActiveItem} />;
      case "View All Booking Config":
        return <Bookingconfigs />;
        case "Coupons Configuration":
        return <Coupons />;
        case "Cancellation Policies Configuration":
        return <Cancellationpolicies />;
      default:
        return <Typography>Need Access</Typography>;
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 3000);
    return () => clearTimeout(timer);
  }, []);

  // useEffect(() => {
  //   const loginTime = localStorage.getItem("loginTime");
  //   if (!loginTime || Date.now() - Number(loginTime) > 2 * 60 * 60 * 1000) {
  //     localStorage.clear();
  //     navigate("/");
  //   }
  // }, [navigate]);

  if (isLoading) return <Loading />;

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Layout
        module={"peakseason"}
        activeItem={activeItem}
        setActiveItem={setActiveItem}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          backgroundImage: "linear-gradient(to top, #ffffff, #d4dfed)",
          width: "50%",
        }}
      >
        <Toolbar />
        <Container
          maxWidth={false}
          sx={{ flexGrow: 1, minHeight: "100vh", overflow: "hidden" }}
        >
          {renderContent()}
        </Container>
      </Box>
    </Box>
  );
};

export default Peakseasonmodule;
